import { RESET_STATE } from 'store/global/actions';

import { TPO_STATUS_DEFINITIONS_ACTION_TYPE } from '../actions';

const initialState = {
  list: [],
};

const applyOrder = ({ list, kind, orderedDefinitionIds }) =>
  list.map(definition => {
    const index = orderedDefinitionIds.indexOf(definition.tpoStatusDefinitionId);

    return definition.kind === kind && index !== -1 ? { ...definition, order: index } : definition;
  });

const tpoStatusDefinitionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TPO_STATUS_DEFINITIONS_ACTION_TYPE.GET_LIST:
      return { ...state, list: Array.isArray(payload) ? payload : [] };

    case TPO_STATUS_DEFINITIONS_ACTION_TYPE.CREATE:
      return { ...state, list: [...state.list, payload] };

    case TPO_STATUS_DEFINITIONS_ACTION_TYPE.UPDATE:
      return {
        ...state,
        list: state.list.map(definition =>
          definition.tpoStatusDefinitionId === payload.tpoStatusDefinitionId ? payload : definition,
        ),
      };

    case TPO_STATUS_DEFINITIONS_ACTION_TYPE.DELETE:
      return {
        ...state,
        list: state.list.filter(definition => definition.tpoStatusDefinitionId !== payload.id),
      };

    case TPO_STATUS_DEFINITIONS_ACTION_TYPE.REORDER:
      return { ...state, list: applyOrder({ list: state.list, ...payload }) };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default tpoStatusDefinitionsReducer;
